import React from "react";
import { NOTIFICATION_STATUSES, STEP_STATUS } from "../notifications.consts";
import palette from "src/theme/palette";
import StatusFailedIcon from "src/icons/StatusFailedIcon";
import StatusInProgressIcon from "src/icons/StatusInProgressIcon";
import StatusNotStartedIcon from "src/icons/StatusNotStartedIcon";
import StatusCompletedIcon from "src/icons/StatusCompletedIcon";
import dayjs from "dayjs";

export const formatDate = (dateString) => dayjs(dateString).format("M/D/YYYY h:mm:ss A");

export const getStepVisuals = (notificationStatus, stepStatus) => {
  if (notificationStatus === NOTIFICATION_STATUSES.FAILED &&
    (stepStatus === STEP_STATUS.COMPLETED || stepStatus === STEP_STATUS.SKIPPED)) {
    return {
      textColor: palette.text[700],
      lineColor: palette.grey[300],
      icon: <StatusCompletedIcon color={palette.grey[500]} />
    };
  }

  if (stepStatus === STEP_STATUS.FAILED) {
    return {
      textColor: palette.error[400],
      lineColor: palette.grey[200],
      icon: <StatusFailedIcon />
    };
  }
  if (stepStatus === STEP_STATUS.IN_PROGRESS) {
    return {
      textColor: palette.info[600],
      lineColor: palette.grey[200],
      icon: <StatusInProgressIcon />
    };
  }
  if (stepStatus === STEP_STATUS.NOT_STARTED) {
    return {
      textColor: palette.secondary[700],
      lineColor: palette.grey[200],
      icon: <StatusNotStartedIcon />
    };
  }
  if (stepStatus === STEP_STATUS.SKIPPED) {
    return {
      textColor: palette.text[600],
      lineColor: palette.grey[300],
      icon: <StatusCompletedIcon />
    };
  }
  if (notificationStatus === NOTIFICATION_STATUSES.CANCELED) {
    return {
      lineColor: palette.grey[200],
      icon: <StatusNotStartedIcon />
    };
  }

  return {
    textColor: palette.success[500],
    lineColor: palette.grey[300],
    icon: <StatusCompletedIcon />
  };
};
